class ProductPdf extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    
    this.buttonWithPrice = this.element.querySelector('[id^="ProductInPdfButtonWithPrice-"]');
    this.buttonWithoutPrice = this.element.querySelector('[id^="ProductInPdfButtonWithoutPrice-"]');
    this.blockSettings = JSON.parse(this.element.getAttribute('data-block-settings'));   

    this.requestOrigin = this.blockSettings["requestOrigin"];   
    this.price = this.blockSettings["price"];
    this.featuredMedia = this.blockSettings["featuredMedia"];    
    this.infoAppellation = this.blockSettings["infoAppellation"];
    this.infoCentilisation = this.blockSettings["infoCentilisation"];
    this.infoCepages = this.blockSettings["infoCepages"];
    this.infoType = this.blockSettings["infoType"];
    this.infoVigneron = this.blockSettings["infoVigneron"];
    this.infoBio = this.blockSettings["infoBio"];
    this.infoDegre = this.blockSettings["infoDegre"];
    
    // Don't use JSON parse for problem in string
    this.logo = this.element.dataset.logoUrl;
    this.title = this.element.dataset.title;
    this.description = this.element.dataset.description;
    this.degustation = this.element.dataset.degustation;
    this.infoAllergens = this.element.dataset.allergens;
    this.allergenItems = this.infoAllergens.split('\n');

    this.imgUrl = `${this.requestOrigin}/cdn/shop/${this.featuredMedia}`;

    this.onClick();
  }

  onClick() {
    let withPrice = true;
    this.buttonWithPrice.addEventListener('click', () => {
      withPrice = true;
      this.createPdf(withPrice);
    });
    this.buttonWithoutPrice.addEventListener('click', () => {
      withPrice = false;
      this.createPdf(withPrice = false);
    });
  }

  createPdf(withPrice = true) {
    const doc = new window.jspdf.jsPDF();
    const margin = 0.5;

    // HEADER
    // Background color
    doc.setDrawColor(0);
    doc.setFillColor(183, 23, 63);
    doc.rect(0, 0, 300, 25, "F");

    // Start convert logo to base64
    const logo = new Image();
    logo.crossOrigin='anonymous';
    
    logo.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.height = logo.naturalHeight;
      canvas.width = logo.naturalWidth;
      ctx.drawImage(logo, 0, 0);
      const dataUrl = canvas.toDataURL();
    }
    
    logo.src = this.logo;
    // End convert logo to base64

    // Logo
    doc.addImage(this.logo, 'PNG', 10, 8, 50, 10);

    // Hyperlink to the site
    doc.setFontSize(9);
    doc.setTextColor(255, 255, 255);
    doc.textWithLink(this.requestOrigin, 163, 13, {url: this.requestOrigin});
    doc.setDrawColor(255, 255, 255);
    doc.setLineWidth(0.1);
    doc.line(163, 14, 197, 14); // horizontal line  

    // PRODUCT INFORMATIONS
    doc.setTextColor(0, 0, 0);
    
    // Start convert product image to base64
    const image = new Image();
    image.crossOrigin='anonymous';
    
    image.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.height = image.naturalHeight;
      canvas.width = image.naturalWidth;
      ctx.drawImage(image, 0, 0);
      const dataUrl = canvas.toDataURL();
    }
    
    image.src = this.imgUrl;
    // End convert product image to base64

    // Product featured media
    if (this.imgUrl.includes("jpg")) {
      doc.addImage(this.imgUrl, 'JPG', 10, 30, 70, 110);
    } else if (this.imgUrl.includes("jpeg")) {
      doc.addImage(this.imgUrl, 'JPEG', 10, 30, 70, 110);
    } else if (this.imgUrl.includes("png")) {
      doc.addImage(this.imgUrl, 'PNG', 10, 30, 70, 110);
    }
    
    // Product title
    const maxLineForTitle = 40 - margin * 2,
          title = doc.splitTextToSize(`${this.title}`, maxLineForTitle);
    doc.setFontSize(22);
    doc.text(title, 110, 45);

    // Product price
    if (withPrice) {
      doc.setFontSize(14);
      doc.text(`${this.price}`, 110, 75);
    }

    // Product informations (metafields)
    doc.setFontSize(18);
    doc.text("Informations", 110, 85);
    
    doc.setFontSize(10);

    // Info Appellation
    doc.setFont("helvetica", "bold");
    doc.text("Appellation:", 110, 95);
    doc.setFont("helvetica", "normal");
    if (this.infoAppellation.length) {
      doc.text(this.infoAppellation, 132, 95);
    } else {
      doc.text("(Non communiqué)", 132, 95);
    }

    // Info Centilisation
    doc.setFont("helvetica", "bold");
    doc.text("Contenant:", 110, 100);
    doc.setFont("helvetica", "normal");
    if (this.infoCentilisation.length) {
      doc.text(this.infoCentilisation, 132, 100);
    } else {
      doc.text("(Non communiqué)", 132, 100);
    }

    // Info Cepages
    doc.setFont("helvetica", "bold");
    doc.text("Cépages:", 110, 105);
    doc.setFont("helvetica", "normal");
    if (this.infoCepages.length) {
      doc.text(this.infoCepages, 132, 105);
    } else {
      doc.text("(Non communiqué)", 132, 105);
    }

    // Info Type
    doc.setFont("helvetica", "bold");
    doc.text("Type:", 110, 110);
    doc.setFont("helvetica", "normal");
    if (this.infoType.length) {
      doc.text(this.infoType, 132, 110);
    } else {
      doc.text("(Non communiqué)", 132, 110);
    }

    // Info Vigneron
    doc.setFont("helvetica", "bold");
    doc.text("Vigneron:", 110, 115);
    doc.setFont("helvetica", "normal");
    if (this.infoVigneron.length) {
      doc.text(this.infoVigneron, 132, 115);
    } else {
      doc.text("(Non communiqué)", 132, 115);
    }
    
    // Info Bio
    doc.setFont("helvetica", "bold");
    doc.text("Viticulture:", 110, 120);
    doc.setFont("helvetica", "normal");
    if (this.infoBio.length) {
      doc.text(this.infoBio, 132, 120);
    } else {
      doc.text("(Non communiqué)", 132, 120);
    }

    // Info Degre
    doc.setFont("helvetica", "bold");
    doc.text("Degré:", 110, 125);
    doc.setFont("helvetica", "normal");
    if (this.infoDegre.length) {
      doc.text(this.infoDegre, 132, 125);
    } else {
      doc.text("(Non communiqué)", 132, 125);
    }

    // Info Allergens
    doc.setFont("helvetica", "bold");
    doc.text("Allergène:", 110, 130);
    doc.setFont("helvetica", "normal");
    
    if (this.infoAllergens.length > 0) {
      if (this.infoAllergens.length > 1) {
        const maxLineWidthTitle = 70 - margin * 2;
        const infoAllergens = doc.splitTextToSize(`${this.infoAllergens}`, maxLineWidthTitle);
        doc.text(infoAllergens, 132, 130);
      } else {
        doc.text(this.infoAllergens, 132, 130);
      }
    } else {
      doc.text("Contient des sulfites", 132, 130);
    }

    // Body text
    const maxLineForBodyText = 185 - margin * 2;
    
    // Info Degustation
    if (this.degustation.length) {
      doc.setFontSize(18);
      doc.text("Dégustation", 10, 165);    
      doc.setFontSize(10);    
      const degustation = doc.splitTextToSize(`${this.degustation}`, maxLineForBodyText);
      doc.text(degustation, 10, 174);
    }

    // Product description
    if (this.description.length) {
      doc.setFontSize(18);
      doc.text("Description", 10, 195);    
      doc.setFontSize(10);    
      const description = doc.splitTextToSize(`${this.description}`, maxLineForBodyText);
      doc.text(description, 10, 204);
    }

    // FOOTER
    // Background color
    doc.setDrawColor(0);
    doc.setFillColor(183, 23, 63);
    doc.rect(0, 260, 300, 38, "F");
    
    // Shop contact details
    doc.setTextColor(255, 255, 255);
    
    // Fribourg
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("Fribourg", 10, 270);
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text("Adresse: Rte du Mont Carmel 1,", 10, 277);
    doc.text("1762 Givisiez, Suisse", 10, 282);
    doc.text("Téléphone: +41 26 465 22 22", 10, 287);

    // Bulle
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("Bulle", 80, 270);
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text("Adresse: Rue du Château-d'En-Bas 30,", 80, 277);
    doc.text("1630 Bulle, Suisse", 80, 282);
    doc.text("Téléphone: +41 26 912 32 32", 80, 287);

    // Lausanne
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("Lausanne", 155, 270);
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text("Adresse: Rue Marterey 34,", 155, 277);
    doc.text("1005 Lausanne, Suisse", 155, 282);
    doc.text("Téléphone: +41 21 312 01 01", 155, 287);
      
    doc.save(`${this.title}.pdf`);
  }
}

customElements.define('product-pdf', ProductPdf);